module.exports = __webpack_public_path__ + "img/greet.f15e33db.png";